// All Romanian + English copy + structured data for MAX Fitness.
// Switch language via i18n context - all text comes through `t(key)`.

export const SITE = {
  brand: "MAX",
  brandSuffix: "Fitness",
  phone: "+40 739 473 571",
  email: "info@max-fit.ro",
  address: "Strada Midiei &, Aleea Cabanei, 905700 Năvodari, România",
  shortAddress: "Constanța, Năvodari",
  social: {
    facebook: "https://www.facebook.com/MaxFitNavodari/",
    instagram: "https://www.instagram.com/maxfitnavodari/",
  },
  mapEmbed:
    "https://www.google.com/maps?q=Strada%20Midiei%20%26%2C%20Aleea%20Cabanei%2C%20905700%20N%C4%83vodari&output=embed",
  mapShareUrl: "https://www.google.com/maps/search/?api=1&query=Strada%20Midiei%20%26%2C%20Aleea%20Cabanei%2C%20905700%20N%C4%83vodari",
  openMapUrl: "https://maps.app.goo.gl/XgWmTBZYJyv2FgCV7",
  reviewsUrl: "https://www.google.com/search?sca_esv=fec7a8aac00c39eb&q=https://www.google.com/maps/search/%3Fapi%3D1%26query%3DMax%2BFitness%2BNavodari&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qObSWUBPRuJgLzEvdlBpCfrZM1C9J4tvi5DtQSgF-lRDomKU9ZJrhzltYRaqnRx2Eezp4VSA%3D&uds=ALYpb_nXwSlQavF8kwYtOXKmjiLnzoHVEoXk4og5jE0aPyUOzi13MW_-4prujth35ZoKcRAdoSMnR_VcsZdwE3lmW2E2Zs7ZiuE7hYKQwLffUOqA-3iu6fp3nS6OdnjaVPffCXMljaRus2UOQW9osFq2pnsdLnJXbG4ThCG4Lvg4XImoFi8_xe2ymGT8kxs5kDThqiFiYCQ9&sa=X&ved=2ahUKEwiSrNCIyJOUAxVhwQIHHdqeITAQ3PALegQIGRAF",
};

/** Local files in `public/gallery/` — order = gallery order. */
export const GALLERY_SOURCES = [
  "/gallery/strength-room-01.webp",
  "/gallery/strength-room-02.webp",
  "/gallery/strength-room-03.webp",
  "/gallery/strength-room-04.webp",
  "/gallery/strength-room-05.webp",
  "/gallery/strength-room-06.webp",
  "/gallery/cardio-zone-01.webp",
  "/gallery/cardio-zone-02.webp",
  "/gallery/lockers-changing-01.webp",
  "/gallery/lockers-changing-02.webp",
  "/gallery/reception-01.webp",
  "/gallery/kids-area-01.webp",
];

export const PHOTOS = {
  /** Hero background; same as first gallery image. */
  hero: "/gallery/strength-room-01.webp",
};

/** Trainer cards — order preserved. Ukraine badge for Vitalyi is hardcoded in TrainersModal by id. */
export const TRAINERS = [
  { id: "caniggia", photo: "/trainers/caniggia.png" },
  { id: "denisa", photo: "/trainers/denisa.png" },
  { id: "valentin", photo: "/trainers/valentin.png" },
  { id: "cristina", photo: "/trainers/cristina.png" },
  { id: "gabriela", photo: "/trainers/gabriela.png" },
  { id: "anamaria", photo: "/trainers/anamaria.png" },
  { id: "vitalyi", photo: "/trainers/vitalyi.png" },
  { id: "alex", photo: "/trainers/alex.png" },
  { id: "cosmin", photo: "/trainers/cosmin.png" },
  { id: "alexandra", photo: "/trainers/alexandra.jpg" },
  { id: "serhii", photo: "/trainers/serhii.jpg" },
];

// ========== PRICING DATA (language-aware via t() for labels, prices stay numeric) ==========
// Plan id → meta. Cards reference them; the modal uses these to render the dropdown.
export const PRICING_PLANS = {
  individual: [
    { id: "sala-full", price: 160, popular: true },
    { id: "sala-part", price: 150 },
    { id: "per-3l", price: 450 },
    { id: "per-6l", price: 900 },
    { id: "per-12l", price: 1800, popular: true },
  ],
  sala: [
    { id: "ind-acces-unic", price: 35 },
    { id: "per-1s", price: 80 },
    { id: "per-2s", price: 120 },
  ],
  clase: [
    { id: "clase-aerobic", price: 200 },
    { id: "clase-aerobic-sala", price: 280 },
  ],
  perioada: [
    { id: "ind-sedinta-pt", price: 50 },
    { id: "ind-abonament-pt", price: 180 },
  ],
  copii: [
    { id: "copii-7-12", price: 100 },
    { id: "sala-elevi", price: 150 },
  ],
};

// ========== TRANSLATIONS ==========
const ro = {
  langName: "Română",
  langShort: "RO",

  nav: {
    home: "Acasă",
    about: "Despre",
    gallery: "Fotografii",
    pricing: "Tarife",
    faq: "FAQ",
    contact: "Contact",
    buy: "Cumpără",
    openMenu: "Deschide meniul",
    closeMenu: "Închide meniul",
  },

  hero: {
    badge: "Sală de fitness premium în Năvodari",
    description: "Echipamente moderne și confort pentru training în ritmul tău.",
    cta1: "Cumpără abonament",
    cta2: "Vezi fotografiile sălii",
    link: "Antrenorii noștri",
    indicators: {
      open: "Deschis acum",
      reviews: "Google Reviews",
      machines: "aparate moderne",
      city: "Constanța",
    },
  },

  bento: {
    label: "ANTRENEAZĂ-TE CU ABONAMENTUL TĂU",
    titleA: "Acceptăm ESX",
    titleB: "și SanoPass",
    description:
      "Dacă abonamentul tău include sala noastră, te poți antrena la noi fără cost suplimentar.",
    partnerNote: "Acceptăm cele mai populare carduri corporate de wellness — fără costuri suplimentare.",
    partners: "Parteneri",
    openMap: "Deschide harta",
    features: [
      { value: "50+", label: "aparate", icon: "Dumbbell" },
      { value: "Loc", label: "joacă", icon: "Baby" },
      { value: "Cardio", label: "zonă", icon: "Activity" },
      { value: "Dușuri", label: "și toalete", icon: "Droplets" },
      { value: "Dulapuri", label: "și vestiare", icon: "Lock" },
      { value: "Apă", label: "și curățenie", icon: "GlassWater" },
      { value: "Trainer", label: "mentor", icon: "UserCheck" },
      { value: "Relaxare", label: "zonă specială", icon: "Sofa" },
    ],
    reviews: {
      label: "GOOGLE REVIEWS",
      count: "133 recenzii",
      rating: "4,6",
      cta: "Vezi recenziile",
    },
  },

  gallery: {
    eyebrow: "Galerie locală",
    title1: "Zonele clubului",
    title2: "nostru",
    desc: "Sală de forță, cardio, spinning și vestiare moderne.",
    images: [
      "Sală de forță",
      "Sală de forță",
      "Sală de forță",
      "Sală de forță",
      "Sală de forță",
      "Sală de forță",
      "Zonă cardio",
      "Zonă cardio",
      "Vestiare & dulapuri",
      "Vestiare & dulapuri",
      "Recepție",
      "Zonă copii",
    ],
  },

  pricing: {
    title1: "Alege formatul de vizitare",
    title2: "potrivit ritmului tău",
    subtitle:
      "Tarife clare, fără comisioane ascunse — alege un abonament potrivit programului tău.",
    chooseCta: "Alege abonamentul",
    viewTrainersCta: "Vezi antrenorii",
    pricePer: "lei",
    badgePopular: "Cel mai popular",
    badgeBest: "Cea mai bună alegere",
    aerobicInfo: {
      open: "Deschide informațiile despre clase",
      title: "Informatii",
      intro: "Aceste cursuri sunt incluse in program:",
      items: [
        "Pilates",
        "Spinning",
        "Cardio kick-boxing",
        "Step aerobic",
        "Rebound",
        "Body pump",
        "Yoga aeriana",
        "TRX",
        "Hula hoop",
      ],
    },
    tabs: {
      individual: { label: "Abonamente principale", icon: "Zap" },
      sala: { label: "Acces unic & sesiune", icon: "Dumbbell" },
      clase: { label: "Aerobic", icon: "PersonStanding" },
      perioada: { label: "Trainer", icon: "Calendar" },
      copii: { label: "Elevi/copii", icon: "Baby" },
    },
    plans: {
      "ind-acces-unic": {
        name: "Vizita unica",
        features: [
          "O singura vizita",
          "Vizita in orice interval de lucru",
          "Acces in sală de forta si zona cardio",
          "Dus, toaleta si vestiar",
        ],
      },
      "ind-sedinta-pt": {
        name: "Antrenor personal (1 sedinta)",
        features: [
          "Poti alege antrenorul dorit",
          "Antrenament individual",
          "Acces in toate zonele",
          "Acces la dus, toaleta si vestiar",
        ],
      },
      "ind-abonament-pt": {
        name: "Antrenor personal (luna)",
        features: [
          "Plan individual de antrenament",
          "Plan individual de alimentatie",
          "Comunicare cu antrenorul pentru intrebari",
          "Poti alege antrenorul dorit",
          "Acces in toate zonele",
          "Acces la dus, toaleta si vestiar",
        ],
      },
      "sala-full": {
        name: "Full Time",
        pricePer: "lei / lună",
        features: [
          "Vizite in orice ore de lucru",
          "Acces in sală de forta si zona cardio",
          "Dus, toaleta si vestiar",
        ],
      },
      "sala-part": {
        name: "Part Time",
        pricePer: "lei / lună",
        features: [
          "Vizite pana la 15:00",
          "Acces in sală de forta si zona cardio",
          "Acces la dus, toaleta si vestiar",
        ],
      },
      "sala-elevi": {
        name: "Studenti",
        pricePer: "lei / lună",
        features: [
          "Reducere pentru studenti",
          "Vizite in orice ore de lucru",
          "Acces in sală de forta si zona cardio",
          "Dus, toaleta si vestiar",
        ],
      },
      "clase-aerobic": {
        name: "Aerobic",
        pricePer: "lei / lună",
        features: [
          "Acces la aerobic in fiecare zi: 08:30 - 09:30 si 18:00 - 19:00",
          "Vizita in orice interval de lucru",
          "Dus, toaleta si vestiar",
          { text: "Fara acces la sală de forta si zona cardio", negative: true },
        ],
      },
      "clase-aerobic-sala": {
        name: "Aerobic și sală",
        pricePer: "lei / lună",
        features: [
          "Acces in sală de forta si zona cardio (oricare zi)",
          "Acces la aerobic in fiecare zi: 08:30 - 09:30 si 18:00 - 19:00",
          "Vizita in orice interval de lucru",
          "Dus, toaleta si vestiar",
        ],
      },
      "copii-7-12": {
        name: "Copii (7-12 ani, doar cu insotitor)",
        pricePer: "lei / lună",
        features: [
          "Doar cu insotitor adult",
          "Vizite in orice ore de lucru",
          "Acces in sală de forta si zona cardio",
          "Dus, toaleta si vestiar",
        ],
      },
      "per-1s": {
        name: "1 saptamana",
        features: [
          "Vizite timp de 7 zile",
          "Vizita in orice interval de lucru",
          "Acces in sală de forta si zona cardio",
          "Dus, toaleta si vestiar",
        ],
      },
      "per-2s": {
        name: "2 săptămâni",
        features: [
          "Vizite timp de 14 zile",
          "Vizita in orice interval de lucru",
          "Acces in sală de forta si zona cardio",
          "Dus, toaleta si vestiar",
        ],
      },
      "per-3l": {
        name: "3 luni",
        features: [
          "90 zile de abonament",
          "Vizite in orice ore de lucru",
          "Acces in toate zonele (sală de forta, zona cardio)",
          "Acces la dus, toaleta si vestiar",
        ],
      },
      "per-6l": {
        name: "6 luni",
        features: [
          "182 zile de abonament",
          "Vizite in orice ore de lucru",
          "Acces in toate zonele (sală de forta, zona cardio)",
          "Acces la dus, toaleta si vestiar",
        ],
      },
      "per-12l": {
        name: "12 luni",
        features: [
          "365 zile de abonament",
          "Vizite in orice ore de lucru",
          "Acces in toate zonele (sală de forta, zona cardio)",
          "Acces la dus, toaleta si vestiar",
        ],
      },
    },
  },

  faq: {
    eyebrow: "FAQ",
    title1: "Întrebări frecvente,",
    title2: "răspunsuri clare",
    items: [
      {
        q: "Este necesară încălțămintea de schimb?",
        a: "Da, pentru accesul în sală este obligatorie încălțămintea sport curată de schimb.",
      },
      {
        q: "Aveți dușuri și vestiare?",
        a: "Da, sala dispune de vestiare, dușuri, toalete și dulapuri pentru lucrurile personale.",
      },
      {
        q: "Se poate cumpăra o intrare unică?",
        a: "Da, poți alege o vizită unică fără să fie nevoie de abonament.",
      },
      {
        q: "Există antrenamente cu antrenor personal?",
        a: "Da, poți cumpăra atât o ședință individuală, cât și un abonament de antrenor personal.",
      },
      {
        q: "Cât durează un antrenament?",
        a: "Totul depinde de abonamentul tău. În abonament este indicat pentru cât timp ai acces.",
      },
    ],
  },

  trainers: {
    title: "Antrenorii noștri",
    subtitle: "Echipa din spatele fiecărui antrenament.",
    aboutMe: "Despre mine",
    aboutEmpty: "Acest antrenor nu a adăugat încă o descriere.",
    flagUaLabel: "Ucraina",
    items: {
      caniggia: { name: "Caniggia", role: "Instructor de fitness" },
      denisa: { name: "Denisa", role: "Instructor de fitness" },
      valentin: { name: "Valentin", role: "Instructor de fitness" },
      cristina: { name: "Cristina", role: "Instructor de dans pentru copii și balet" },
      gabriela: { name: "Gabriela", role: "Instructor de aerobic" },
      anamaria: { name: "Anamaria", role: "Instructor personal fitness" },
      vitalyi: {
        name: "Vitalyi",
        role: "Instructor de fitness, specialist în box thailandez și Muay Thai",
      },
      alex: { name: "Alex", role: "Instructor de fitness și aerobic" },
      cosmin: { name: "Cosmin", role: "Instructor de fitness și kung-fu" },
      alexandra: { name: "Nechita Alexandra", role: "Antrenor Personal" },
    },
  },

  contact: {
    eyebrow: "Contact",
    title1: "Ia legătura",
    title2: "cu MAX Fitness",
    subtitle: "Trimite-ne o întrebare — îți răspundem rapid în timpul programului.",
    formTitle: "Formular de contact",
    fields: { name: "Nume", email: "Emailul tău", message: "Întrebare" },
    placeholders: {
      name: "De exemplu, Andrei",
      email: "De exemplu, example@email.com",
      message: "Scrie întrebarea ta",
    },
    submit: "Trimite",
    sending: "Se trimite...",
    success: "Cererea ta este deja în baza noastră. Te contactăm în scurt timp.",
    error: "A apărut o eroare. Te rugăm să încerci din nou.",
    cards: {
      phone: "Telefon",
      hours: "Lun–Vin · 06:00–22:00 / Sâm–Dum · 08:00–15:00",
      address: "Adresă",
      openMaps: "Deschide în Google Maps",
      email: "Email",
    },
  },

  order: {
    title: "Rezervă abonamentul tău",
    subtitle: "Lasă-ne datele și te contactăm pentru activarea abonamentului.",
    selectLabel: "Abonament selectat",
    selectPlaceholder: "Alege un abonament",
    nameLabel: "Nume",
    namePh: "De exemplu, Andrei",
    phoneLabel: "Telefon",
    phonePh: "De exemplu, +40 7XX XXX XXX",
    emailLabel: "Email",
    emailPh: "De exemplu, example@email.com",
    noteLabel: "Comentariu (opțional)",
    notePh: "Spune-ne ceva în plus despre dorința ta",
    submit: "Trimite cererea",
    sending: "Se trimite...",
    success: "Cererea ta este deja în baza noastră. Te contactăm în scurt timp.",
    error: "Ceva nu a mers — încearcă din nou.",
    selectedSummary: "Abonament:",
    pricePer: "lei",
  },

  footer: {
    description:
      "Sală modernă. Vibe premium. Tarife clare. Fără distrageri.",
    linksTitle: "Linkuri rapide",
    contactTitle: "Contact",
    copyright: (year) => `© 2014–${year} Max Fitness Navodari. Toate drepturile rezervate.`,
    privacy: "Politica de confidențialitate",
    terms: "Termeni și condiții",
    cookies: "Politica de cookies",
  },

  ui: {
    theme: { dark: "Întunecat", light: "Luminos" },
    language: "Limbă",
    close: "Închide",
    next: "Următor",
    prev: "Anterior",
    legalAgree: "Sunt de acord cu",
    and: "și",
  },
};

const en = {
  langName: "English",
  langShort: "EN",

  nav: {
    home: "Home",
    about: "About",
    gallery: "Photos",
    pricing: "Pricing",
    faq: "FAQ",
    contact: "Contact",
    buy: "Buy",
    openMenu: "Open menu",
    closeMenu: "Close menu",
  },

  hero: {
    badge: "Premium fitness club in Năvodari",
    description: "Modern equipment and comfort for training at your own pace.",
    cta1: "Buy membership",
    cta2: "See gym photos",
    link: "Our trainers",
    indicators: {
      open: "Open now",
      reviews: "Google Reviews",
      machines: "modern machines",
      city: "Constanța",
    },
  },

  bento: {
    label: "TRAIN WITH YOUR EXISTING PASS",
    titleA: "We accept ESX",
    titleB: "and SanoPass",
    description:
      "If your subscription includes our gym, you can train here at no extra cost.",
    partnerNote: "We accept the most popular corporate wellness cards — at no extra cost.",
    partners: "Partners",
    openMap: "Open map",
    features: [
      { value: "50+", label: "machines", icon: "Dumbbell" },
      { value: "Kids", label: "play area", icon: "Baby" },
      { value: "Cardio", label: "zone", icon: "Activity" },
      { value: "Showers", label: "& toilets", icon: "Droplets" },
      { value: "Lockers", label: "& changing", icon: "Lock" },
      { value: "Water", label: "& cleanliness", icon: "GlassWater" },
      { value: "Coach", label: "mentor", icon: "UserCheck" },
      { value: "Relax", label: "lounge area", icon: "Sofa" },
    ],
    reviews: {
      label: "GOOGLE REVIEWS",
      count: "133 reviews",
      rating: "4.6",
      cta: "See the reviews",
    },
  },

  gallery: {
    eyebrow: "Local gallery",
    title1: "Inside",
    title2: "our club",
    desc: "Strength room, cardio, spinning and modern locker rooms.",
    images: [
      "Strength room",
      "Strength room",
      "Strength room",
      "Strength room",
      "Strength room",
      "Strength room",
      "Cardio zone",
      "Cardio zone",
      "Lockers & changing",
      "Lockers & changing",
      "Reception",
      "Kids area",
    ],
  },

  pricing: {
    title1: "Pick the plan that fits",
    title2: "your rhythm",
    subtitle: "Clear pricing, no hidden fees — choose a plan that suits your schedule.",
    chooseCta: "Choose plan",
    viewTrainersCta: "Meet the trainers",
    pricePer: "lei",
    badgePopular: "Most popular",
    badgeBest: "Best value",
    aerobicInfo: {
      open: "Open classes information",
      title: "Information",
      intro: "These classes are included in the program:",
      items: [
        "Pilates",
        "Spinning",
        "Cardio kick-boxing",
        "Step aerobics",
        "Rebound",
        "Body pump",
        "Aerial yoga",
        "TRX",
        "Hula hoop",
      ],
    },
    tabs: {
      individual: { label: "Membership", icon: "Zap" },
      sala: { label: "Single access & session", icon: "Dumbbell" },
      clase: { label: "Aerobics", icon: "PersonStanding" },
      perioada: { label: "Trainer", icon: "Calendar" },
      copii: { label: "Students / kids", icon: "Baby" },
    },
    plans: {
      "ind-acces-unic": {
        name: "Single visit",
        features: [
          "One visit only",
          "Visit during any opening hours",
          "Access to strength room and cardio zone",
          "Shower, toilet and locker",
        ],
      },
      "ind-sedinta-pt": {
        name: "Personal trainer (1 session)",
        features: [
          "You can choose your trainer",
          "Individual training",
          "Access to all zones",
          "Access to shower, toilet and locker",
        ],
      },
      "ind-abonament-pt": {
        name: "Personal trainer (month)",
        features: [
          "Individual training plan",
          "Individual nutrition plan",
          "Communication with your trainer for questions",
          "You can choose your trainer",
          "Access to all zones",
          "Access to shower, toilet and locker",
        ],
      },
      "sala-full": {
        name: "Full Time",
        pricePer: "lei / month",
        features: [
          "Visits during all opening hours",
          "Access to strength room and cardio zone",
          "Shower, toilet and locker",
        ],
      },
      "sala-part": {
        name: "Part Time",
        pricePer: "lei / month",
        features: [
          "Visits until 15:00",
          "Access to strength room and cardio zone",
          "Access to shower, toilet and locker",
        ],
      },
      "sala-elevi": {
        name: "Students",
        pricePer: "lei / month",
        features: [
          "Student discount",
          "Visits during all opening hours",
          "Access to strength room and cardio zone",
          "Shower, toilet and locker",
        ],
      },
      "clase-aerobic": {
        name: "Aerobics",
        pricePer: "lei / month",
        features: [
          "Aerobics access every day: 08:30 - 09:30 and 18:00 - 19:00",
          "Visit during any opening hours",
          "Shower, toilet and locker",
          { text: "No access to strength room and cardio zone", negative: true },
        ],
      },
      "clase-aerobic-sala": {
        name: "Aerobics & gym",
        pricePer: "lei / month",
        features: [
          "Access to strength room and cardio zone (any day)",
          "Aerobics access every day: 08:30 - 09:30 and 18:00 - 19:00",
          "Visit during any opening hours",
          "Shower, toilet and locker",
        ],
      },
      "copii-7-12": {
        name: "Kids (7–12 yrs, adult companion required)",
        pricePer: "lei / month",
        features: [
          "Adult companion required",
          "Visits during all opening hours",
          "Access to strength room and cardio zone",
          "Shower, toilet and locker",
        ],
      },
      "per-1s": {
        name: "1 week",
        features: [
          "Visits for 7 days",
          "Visit during any opening hours",
          "Access to strength room and cardio zone",
          "Shower, toilet and locker",
        ],
      },
      "per-2s": {
        name: "2 weeks",
        features: [
          "Visits for 14 days",
          "Visit at any working hour",
          "Access to gym and cardio area",
          "Shower, restroom, and locker room",
        ],
      },
      "per-3l": {
        name: "3 months",
        features: [
          "90 days of membership",
          "Visits during all opening hours",
          "Access to all zones (strength room, cardio)",
          "Access to shower, toilet and locker",
        ],
      },
      "per-6l": {
        name: "6 months",
        features: [
          "182 days of membership",
          "Visits during all opening hours",
          "Access to all zones (strength room, cardio)",
          "Access to shower, toilet and locker",
        ],
      },
      "per-12l": {
        name: "12 months",
        features: [
          "365 days of membership",
          "Visits during all opening hours",
          "Access to all zones (strength room, cardio)",
          "Access to shower, toilet and locker",
        ],
      },
    },
  },

  faq: {
    eyebrow: "FAQ",
    title1: "Frequently asked,",
    title2: "clearly answered",
    items: [
      {
        q: "Do I need indoor sport shoes?",
        a: "Yes, clean indoor sport shoes are required for entry to the gym floor.",
      },
      {
        q: "Do you have showers and changing rooms?",
        a: "Yes, the gym has changing rooms, showers, toilets and lockers for personal items.",
      },
      {
        q: "Can I buy a single entry?",
        a: "Yes, you can choose a single visit without needing a full membership.",
      },
      {
        q: "Do you offer personal training?",
        a: "Yes, you can buy either a single session or a personal training pass.",
      },
      {
        q: "How long is a workout?",
        a: "It depends on your plan — your pass states exactly how much time you have.",
      },
    ],
  },

  trainers: {
    title: "Our trainers",
    subtitle: "The team behind every workout.",
    aboutMe: "About me",
    aboutEmpty: "This trainer has not added an About me text yet.",
    flagUaLabel: "Ukraine",
    items: {
      caniggia: { name: "Caniggia", role: "Fitness instructor" },
      denisa: { name: "Denisa", role: "Fitness instructor" },
      valentin: { name: "Valentin", role: "Fitness instructor" },
      cristina: { name: "Cristina", role: "Kids’ dance & ballet instructor" },
      gabriela: { name: "Gabriela", role: "Aerobics instructor" },
      anamaria: { name: "Anamaria", role: "Personal fitness instructor" },
      vitalyi: {
        name: "Vitalyi",
        role: "Fitness instructor — Thai boxing & Muay Thai specialist",
      },
      alex: { name: "Alex", role: "Fitness and aerobics instructor" },
      cosmin: { name: "Cosmin", role: "Fitness instructor & kung-fu" },
      alexandra: { name: "Nechita Alexandra", role: "Personal Trainer" },
    },
  },

  contact: {
    eyebrow: "Contact",
    title1: "Get in touch",
    title2: "with MAX Fitness",
    subtitle: "Send us a question — we reply quickly during opening hours.",
    formTitle: "Contact form",
    fields: { name: "Name", email: "Your email", message: "Question" },
    placeholders: {
      name: "For example, Andrew",
      email: "For example, example@email.com",
      message: "Write your question",
    },
    submit: "Send",
    sending: "Sending...",
    success: "Your request is already in our database. We'll be in touch shortly.",
    error: "Something went wrong. Please try again.",
    cards: {
      phone: "Phone",
      hours: "Mon-Fri · 06:30–22:30 / Sat–Sun · 08:00–15:00",
      address: "Address",
      openMaps: "Open in Google Maps",
      email: "Email",
    },
  },

  order: {
    title: "Reserve your membership",
    subtitle: "Leave your details and we'll get back to activate your plan.",
    selectLabel: "Selected plan",
    selectPlaceholder: "Pick a plan",
    nameLabel: "Name",
    namePh: "For example, Andrew",
    phoneLabel: "Phone",
    phonePh: "For example, +40 7XX XXX XXX",
    emailLabel: "Email",
    emailPh: "For example, example@email.com",
    noteLabel: "Note (optional)",
    notePh: "Tell us a bit more about your goal",
    submit: "Send request",
    sending: "Sending...",
    success: "Your request is already in our database. We'll be in touch shortly.",
    error: "Something went wrong — please try again.",
    selectedSummary: "Plan:",
    pricePer: "lei",
  },

  footer: {
    description:
      "Modern gym. Premium vibe. Clear pricing. No distractions.",
    linksTitle: "Quick links",
    contactTitle: "Contact",
    copyright: (year) => `© 2014–${year} Max Fitness Navodari. All rights reserved.`,
    privacy: "Privacy policy",
    terms: "Terms & Conditions",
    cookies: "Cookies policy",
  },

  ui: {
    theme: { dark: "Dark", light: "Light" },
    language: "Language",
    close: "Close",
    next: "Next",
    prev: "Previous",
    legalAgree: "I agree with",
    and: "and",
  },
};

const ua = {
  langName: "Українська",
  langShort: "UA",

  nav: {
    home: "Головна",
    about: "Про нас",
    gallery: "Фото",
    pricing: "Тарифи",
    faq: "FAQ",
    contact: "Контакти",
    buy: "Купити",
    openMenu: "Відкрити меню",
    closeMenu: "Закрити меню",
  },

  hero: {
    badge: "Преміальний фітнес-клуб у Неводарі",
    description: "Сучасне обладнання та комфорт для тренувань у власному ритмі.",
    cta1: "Купити абонемент",
    cta2: "Переглянути фото залу",
    link: "Наші тренери",
    indicators: {
      open: "Відчинено зараз",
      reviews: "Google Reviews",
      machines: "сучасних тренажерів",
      city: "Констанца",
    },
  },

  bento: {
    label: "ТРЕНУЙСЯ ЗІ СВОЇМ АБОНЕМЕНТОМ",
    titleA: "Ми приймаємо ESX",
    titleB: "та SanoPass",
    description:
      "Якщо твій абонемент включає наш зал, ти можеш тренуватися у нас без додаткової оплати.",
    partnerNote: "Ми приймаємо найпопулярніші корпоративні wellness-картки — без додаткових витрат.",
    partners: "Партнери",
    openMap: "Відкрити мапу",
    features: [
      { value: "50+", label: "тренажерів", icon: "Dumbbell" },
      { value: "Дитяча", label: "зона", icon: "Baby" },
      { value: "Кардіо", label: "зона", icon: "Activity" },
      { value: "Душові", label: "та вбиральні", icon: "Droplets" },
      { value: "Шафки", label: "та роздягальні", icon: "Lock" },
      { value: "Вода", label: "та чистота", icon: "GlassWater" },
      { value: "Тренер", label: "ментор", icon: "UserCheck" },
      { value: "Відпочинок", label: "лаунж-зона", icon: "Sofa" },
    ],
    reviews: {
      label: "GOOGLE REVIEWS",
      count: "133 відгуки",
      rating: "4,6",
      cta: "Переглянути відгуки",
    },
  },

  gallery: {
    eyebrow: "Локальна галерея",
    title1: "Зони нашого",
    title2: "клубу",
    desc: "Силова зала, кардіо, спінінг і сучасні роздягальні.",
    images: [
      "Силова зала",
      "Силова зала",
      "Силова зала",
      "Силова зала",
      "Силова зала",
      "Силова зала",
      "Кардіо-зона",
      "Кардіо-зона",
      "Шафки та роздягальні",
      "Шафки та роздягальні",
      "Рецепція",
      "Дитяча зона",
    ],
  },

  pricing: {
    title1: "Обери формат відвідування",
    title2: "під свій ритм",
    subtitle:
      "Прозорі тарифи без прихованих комісій — обери абонемент, який підходить саме твоєму графіку.",
    chooseCta: "Обрати абонемент",
    viewTrainersCta: "Подивитися тренерів",
    pricePer: "леїв",
    badgePopular: "Найпопулярніший",
    badgeBest: "Найкращий вибір",
    aerobicInfo: {
      open: "Відкрити інформацію про класи",
      title: "Інформація",
      intro: "У програму входять такі заняття:",
      items: [
        "Пілатес",
        "Спінінг",
        "Кардіо кікбоксинг",
        "Степ-аеробіка",
        "Rebound",
        "Body pump",
        "Повітряна йога",
        "TRX",
        "Hula hoop",
      ],
    },
    tabs: {
      individual: { label: "Абонементи", icon: "Zap" },
      sala: { label: "Разовий доступ і сесія", icon: "Dumbbell" },
      clase: { label: "Аеробіка", icon: "PersonStanding" },
      perioada: { label: "Тренер", icon: "Calendar" },
      copii: { label: "Студенти / діти", icon: "Baby" },
    },
    plans: {
      "ind-acces-unic": {
        name: "Разове відвідування",
        features: [
          "Одне відвідування",
          "Візит у будь-який робочий час",
          "Доступ до силової зали та кардіо-зони",
          "Душ, вбиральня та роздягальня",
        ],
      },
      "ind-sedinta-pt": {
        name: "Персональний тренер (1 заняття)",
        features: [
          "Можеш обрати потрібного тренера",
          "Індивідуальне тренування",
          "Доступ до всіх зон",
          "Доступ до душу, вбиральні та роздягальні",
        ],
      },
      "ind-abonament-pt": {
        name: "Персональний тренер (місяць)",
        features: [
          "Індивідуальний план тренувань",
          "Індивідуальний план харчування",
          "Спілкування з тренером для запитань",
          "Можеш обрати потрібного тренера",
          "Доступ до всіх зон",
          "Доступ до душу, вбиральні та роздягальні",
        ],
      },
      "sala-full": {
        name: "Full Time",
        pricePer: "леїв / місяць",
        features: [
          "Відвідування в будь-який робочий час",
          "Доступ до силової зали та кардіо-зони",
          "Душ, вбиральня та роздягальня",
        ],
      },
      "sala-part": {
        name: "Part Time",
        pricePer: "леїв / місяць",
        features: [
          "Відвідування до 15:00",
          "Доступ до силової зали та кардіо-зони",
          "Доступ до душу, вбиральні та роздягальні",
        ],
      },
      "sala-elevi": {
        name: "Студенти",
        pricePer: "леїв / місяць",
        features: [
          "Знижка для студентів",
          "Відвідування в будь-який робочий час",
          "Доступ до силової зали та кардіо-зони",
          "Душ, вбиральня та роздягальня",
        ],
      },
      "clase-aerobic": {
        name: "Аеробіка",
        pricePer: "леїв / місяць",
        features: [
          "Доступ до аеробіки щодня: 08:30 - 09:30 та 18:00 - 19:00",
          "Візит у будь-який робочий час",
          "Душ, вбиральня та роздягальня",
          { text: "Без доступу до силової зали та кардіо-зони", negative: true },
        ],
      },
      "clase-aerobic-sala": {
        name: "Аеробіка та зал",
        pricePer: "леїв / місяць",
        features: [
          "Доступ до силової зали та кардіо-зони (у будь-який день)",
          "Доступ до аеробіки щодня: 08:30 - 09:30 та 18:00 - 19:00",
          "Візит у будь-який робочий час",
          "Душ, вбиральня та роздягальня",
        ],
      },
      "copii-7-12": {
        name: "Діти (7–12 років, тільки з дорослим)",
        pricePer: "леїв / місяць",
        features: [
          "Лише з дорослим супроводом",
          "Відвідування в будь-який робочий час",
          "Доступ до силової зали та кардіо-зони",
          "Душ, вбиральня та роздягальня",
        ],
      },
      "per-1s": {
        name: "1 тиждень",
        features: [
          "Відвідування протягом 7 днів",
          "Візит у будь-який робочий час",
          "Доступ до силової зали та кардіо-зони",
          "Душ, вбиральня та роздягальня",
        ],
      },
      "per-2s": {
        name: "2 тижні",
        features: [
          "Відвідування протягом 14 днів",
          "Візит у будь-який робочий час",
          "Доступ до залу та кардіо-зони",
          "Душ, вбиральня та роздягальня",
        ],
      },
      "per-3l": {
        name: "3 місяці",
        features: [
          "90 днів абонемента",
          "Відвідування в будь-який робочий час",
          "Доступ до всіх зон (силова зала, кардіо)",
          "Доступ до душу, вбиральні та роздягальні",
        ],
      },
      "per-6l": {
        name: "6 місяців",
        features: [
          "182 дні абонемента",
          "Відвідування в будь-який робочий час",
          "Доступ до всіх зон (силова зала, кардіо)",
          "Доступ до душу, вбиральні та роздягальні",
        ],
      },
      "per-12l": {
        name: "12 місяців",
        features: [
          "365 днів абонемента",
          "Відвідування в будь-який робочий час",
          "Доступ до всіх зон (силова зала, кардіо)",
          "Доступ до душу, вбиральні та роздягальні",
        ],
      },
    },
  },

  faq: {
    eyebrow: "FAQ",
    title1: "Поширені запитання,",
    title2: "чіткі відповіді",
    items: [
      {
        q: "Чи потрібне змінне спортивне взуття?",
        a: "Так, для входу до залу потрібне чисте змінне спортивне взуття.",
      },
      {
        q: "У вас є душові та роздягальні?",
        a: "Так, у залі є роздягальні, душові, вбиральні та шафки для особистих речей.",
      },
      {
        q: "Чи можна купити разове відвідування?",
        a: "Так, ти можеш обрати разовий візит без потреби купувати повний абонемент.",
      },
      {
        q: "Чи є у вас персональні тренування?",
        a: "Так, можна придбати як одне заняття, так і абонемент на персональні тренування.",
      },
      {
        q: "Скільки триває тренування?",
        a: "Це залежить від твого тарифу — в абонементі вказано точний час доступу.",
      },
    ],
  },

  trainers: {
    title: "Наші тренери",
    subtitle: "Команда, що стоїть за кожним тренуванням.",
    aboutMe: "Про мене",
    aboutEmpty: "Цей тренер ще не додав опис.",
    flagUaLabel: "Україна",
    items: {
      caniggia: { name: "Caniggia", role: "Фітнес-інструктор" },
      denisa: { name: "Denisa", role: "Фітнес-інструктор" },
      valentin: { name: "Valentin", role: "Фітнес-інструктор" },
      cristina: { name: "Cristina", role: "Інструкторка з дитячих танців і балету" },
      gabriela: { name: "Gabriela", role: "Інструкторка з аеробіки" },
      anamaria: { name: "Anamaria", role: "Персональна фітнес-інструкторка" },
      vitalyi: {
        name: "Vitalyi",
        role: "Фітнес-інструктор, спеціаліст з тайського боксу та Muay Thai",
      },
      alex: { name: "Alex", role: "Інструктор з фітнесу та аеробіки" },
      cosmin: { name: "Cosmin", role: "Фітнес-інструктор і тренер з кунг-фу" },
      alexandra: { name: "Nechita Alexandra", role: "Персональный тренер" },
    },
  },

  contact: {
    eyebrow: "Контакти",
    title1: "Зв’яжись",
    title2: "з MAX Fitness",
    subtitle: "Надішли нам запитання — ми швидко відповімо в робочий час.",
    formTitle: "Контактна форма",
    fields: { name: "Ім’я", email: "Твій email", message: "Запитання" },
    placeholders: {
      name: "Наприклад, Андрій",
      email: "Наприклад, example@email.com",
      message: "Напиши своє запитання",
    },
    submit: "Надіслати",
    sending: "Надсилаємо...",
    success: "Твоя заявка вже в нашій базі. Ми зв’яжемося з тобою найближчим часом.",
    error: "Щось пішло не так. Будь ласка, спробуй ще раз.",
    cards: {
      phone: "Телефон",
      hours: "Пн–Пт · 06:30–22:30 / Сб–Нд · 08:00–15:00",
      address: "Адреса",
      openMaps: "Відкрити в Google Maps",
      email: "Email",
    },
  },

  order: {
    title: "Забронюй свій абонемент",
    subtitle: "Залиш свої дані, і ми зв’яжемося з тобою для активації тарифу.",
    selectLabel: "Обраний абонемент",
    selectPlaceholder: "Обери абонемент",
    nameLabel: "Ім’я",
    namePh: "Наприклад, Андрій",
    phoneLabel: "Телефон",
    phonePh: "Наприклад, +40 7XX XXX XXX",
    emailLabel: "Email",
    emailPh: "Наприклад, example@email.com",
    noteLabel: "Коментар (необов’язково)",
    notePh: "Розкажи нам трохи більше про свою ціль",
    submit: "Надіслати заявку",
    sending: "Надсилаємо...",
    success: "Твоя заявка вже в нашій базі. Ми зв’яжемося з тобою найближчим часом.",
    error: "Щось пішло не так — спробуй ще раз.",
    selectedSummary: "Абонемент:",
    pricePer: "леїв",
  },

  footer: {
    description:
      "Сучасний зал. Преміальна атмосфера. Прозорі тарифи. Жодних відволікань.",
    linksTitle: "Швидкі посилання",
    contactTitle: "Контакти",
    copyright: (year) => `© 2014–${year} Max Fitness Navodari. Усі права захищені.`,
    privacy: "Політика конфіденційності",
    terms: "Умови та положення",
    cookies: "Політика cookies",
  },

  ui: {
    theme: { dark: "Темна", light: "Світла" },
    language: "Мова",
    close: "Закрити",
    next: "Далі",
    prev: "Назад",
    legalAgree: "Я погоджуюся з",
    and: "та",
  },
};

export const TRANSLATIONS = { ro, en, ua };
